import Vue from 'vue'
import VueRouter from 'vue-router'
import LaunchPage from '@/components/Launch.vue'
import WelcomePage from '@/components/Welcome.vue'
import InstructionsPage from '@/components/Instructions.vue'
import TrainingPage from '@/components/Training.vue'
import CuePage from '@/components/Cue.vue'
import FocusPage from '@/components/Focus.vue'
import ProbePage from '@/components/Probe.vue'
import Outcome from '@/components/Outcome.vue'
import Complete from '@/components/Complete.vue'
import NotFound from '@/components/NotFound.vue'
import Block from '@/components/Block.vue'
import BlankPage from '@/components/BlankPage.vue'
import TrainingCuePage from '@/components/TrainingCue.vue'
import TrainingOutcome from '@/components/TrainingOutcome.vue'

Vue.use(VueRouter)
// registers all of the states for the task
const routes = [
  { name: 'Launch', path: '/', component: LaunchPage },
  { name: 'Welcome', path: '/welcome', component: WelcomePage },
  { name: 'Instructions', path: '/instructions/:page', component: InstructionsPage },
  { name: 'Training', path: '/training', component: TrainingPage },
  { name: 'Cue', path: '/cue', component: CuePage },
  { name: 'Focus', path: '/focus/:page', component: FocusPage },
  { name: 'Probe', path: '/probe', component: ProbePage },
  { name: 'Outcome', path: '/outcome', component: Outcome },
  { name: 'Complete', path: '/complete/:result', component: Complete },
  { name: 'Complete', path: '/complete', component: Complete },
  { name: 'Block', path: '/block', component: Block },
  { name: 'NotFound', path: '*', component: NotFound },
  { name: 'BlankPage', path: '/blank_page/:stage', component: BlankPage },
  { name: 'TrainingCue', path: '/training_cue', component: TrainingCuePage },
  { name: 'TrainingOutcome', path: '/training_outcome', component: TrainingOutcome }
]

export default new VueRouter({ mode: 'abstract', routes })
